import { WifiOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { ReactInternetSpeedMeter } from 'react-internet-meter';
import 'tailwindcss/tailwind.css';

const DisplayNetworkStatus = () => {
  const [speed, setSpeed] = useState('0.0');

  const getWifiColor = (speed) => {
    const speedNum = parseFloat(speed);
    if (speedNum > 50) return 'tw-text-green-500';
    if (speedNum > 20) return 'tw-text-yellow-400';
    return 'tw-text-red-400';
  };

  return (
    <div className="tw-mt-[-5px] tw-flex tw-flex-col tw-items-center tw-text-[10px]">
      <WifiOutlined
        className={`!tw-text-[25px] ${getWifiColor(speed)} tw-animate-pulse`}
      />
      <span className="tw-text-[11.4px]  tw-mt-[6px]">{speed} MB/s</span>

      <ReactInternetSpeedMeter
        txtSubHeading=""
        txtMainHeading=""
        outputType="empty"
        customClassName="tw-hidden"
        pingInterval={3000}
        thresholdUnit="megabyte"
        threshold={100}
        imageUrl="https://images.pexels.com/photos/3396664/pexels-photo-3396664.jpeg"
        downloadSize="1781287"
        callbackFunctionOnNetworkDown={() => {
          // console.warn(`Internet is down or slow: ${speed} MB/s`);
        }}
        callbackFunctionOnNetworkTest={(speed) => setSpeed(speed)}
      />
    </div>
  );
};

export default DisplayNetworkStatus;
